import { selectSigningOut } from '../../store/auth/selectors';
import { LogOutSquareIcon } from '../../assets/icons/common';
import { useDispatch, useSelector } from '../../store/store';
import { setSignOutModal } from '../../store/auth/slice';
import { signOutThunk } from '../../store/auth/thunks';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function SignOut() {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectSigningOut);

    const close = () => dispatch(setSignOutModal(false));

    const confirmSignOut = () => {
        dispatch(signOutThunk())
    };

    return (
        <Modal
            size='sm'
            actions='both'
            title='Sign out'
            closeFunc={close}
            icon={<LogOutSquareIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                onClick: close,
            }}
            confirmButton={{
                text: 'Sign out',
                type: 'Error',
                loading: isLoading,
                onClick: confirmSignOut,
            }}
        >
            <span className={styles.text}>Are you sure you want to sign out ?</span>
        </Modal>
    )
}
